<template>
  <LoadingOverlay :is-loading="!store.hydrated"></LoadingOverlay>
  <div class="container">
    <div class="row" v-if="store.hydrated">
      <div class="col-lg-6">
        <div>
          <label class="structure-label">Structure</label>
          <h1 class="channel-name"> {{ store.structure.pdb }}</h1>
        </div>
        <div>
          <label class="structure-label">Description</label>
          <p class="channel-desc">{{ store.structure.description }}</p>
        </div>
        <div>
          <label class="structure-label channel-tags">Tags</label>
          <div class="channel-tags">
            <span v-if="store.structure.tags.length === 0">
              No tags
            </span>
            <span v-for="(tags, family) in store.structure.tags" :key="family">
              <a v-for="tag in tags" :key="tag" :href="'/structures?tag=' + tag">{{ tag }}</a>
            </span>
          </div>
        </div>
        <div v-if="store.structure.protein">
          <label class="structure-label">Sequence</label>
          <Sequence :store="store"></Sequence>
        </div>
        <div class="mt-4">
          <a class="btn btn-outline-info" :href="store.structure.plicLink" target="_blank">Download</a>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="channel-structure">
          <ProteinViewer :pdb-url="store.structure.plicViewLink" :residue-selection="store.residueSelection"
                         :segment-selection="store.segmentSelection"></ProteinViewer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProteinViewer from "./shared/ProteinViewer.vue";
import LoadingOverlay from "./shared/LoadingOverlay.vue";
import Sequence from "./structure/Sequence.vue";
import {useStructureStore} from "../stores/structureStore";
import {useRoute} from "vue-router";

export default {
  name: "Structure",
  components: {
    ProteinViewer,
    LoadingOverlay,
    Sequence
  },
  setup() {
    const store = useStructureStore();
    const route = useRoute();
    
    // Get structureId from route params or query
    const structureId = route.params.structureId || route.query.structureId || new URLSearchParams(window.location.search).get('structureId') || '';
    store.fetchData(structureId);
    
    return {
      store
    };
  }
};
</script>

<style scoped>
.channel-info {
  margin: 30px 0;
}

.channel-name {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.channel-desc {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.channel-tags {
  margin-bottom: 10px;
}

.channel-tags a {
  background-color: #e5e5e5;
  color: #333;
  padding: 5px 10px;
  margin-right: 10px;
  border-radius: 20px;
  text-decoration: none;
  font-weight: 600;
}

.channel-tags a:hover {
  background-color: #333;
  color: #fff;
}

.channel-structure {
  border: solid;
  border-color: lightgray;
  margin-bottom: 30px;
}

.structure-label {
  font-weight: 550;
}
</style>

